import React from 'react'
import { Link, usePage } from '@inertiajs/react'

import { MdOutlineSupervisedUserCircle } from 'react-icons/md'

import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import StatsCard from '@/Shared/UI/StatsCard'
import CardContainer from '@/Shared/UI/CardContainer'

import DesignationTable from './Shared/DesignationTable'

const Index = () => {
  const {
    services,
    firm,
    total_hr,
    supervisor,
    users,
    type,
    janitors,
    sewer_men
  } = usePage().props

  const {
    data,
    meta: { links }
  } = services

  return (
    <div>
      <h1 className="mb-4 text-3xl font-bold">
        <span className="text-indigo-400">{firm}</span> HR
      </h1>

      <CardContainer>
        <StatsCard
          title="Total HR"
          value={`${total_hr[0]}/${total_hr[1]}`}
          clickable
          icon={() => <Icon name="hr" />}
        />

        <StatsCard
          title="Supervisor"
          value={`${supervisor[0]}/${supervisor[1]}`}
          clickable
          icon={MdOutlineSupervisedUserCircle}
        />

        <StatsCard
          title="Janitors"
          value={`${janitors[0]}/${janitors[1]}`}
          clickable
          icon={() => <Icon name="janitor" />}
        />

        <StatsCard
          title="Sewer Men"
          value={`${sewer_men[0]}/${sewer_men[1]}`}
          clickable
          icon={() => <Icon name="sewer" />}
        />
      </CardContainer>

      <div className="overflow-x-auto rounded bg-white shadow">
        <table className="w-full whitespace-nowrap">
          <thead>
            <tr className="text-left font-bold">
              <th className="px-6 pb-4 pt-5">Sr No.</th>
              <th className="px-6 pb-4 pt-5">Hospital</th>
              <th className="px-6 pb-4 pt-5">Beds</th>
              <th className="px-6 pb-4 pt-5">Package</th>
              <th className="px-6 pb-4 pt-5">Firm</th>
              <th className="px-6 pb-4 pt-5">Supervisor</th>
              <th className="px-6 pb-4 pt-5">Available Supervisor</th>
              <th className="px-6 pb-4 pt-5">Janitors</th>
              <th className="px-6 pb-4 pt-5">Available Janitors</th>
              <th className="px-6 pb-4 pt-5">Sewer men</th>
              <th className="px-6 pb-4 pt-5">Available Sewer men</th>
              <th className="px-6 pb-4 pt-5">Total</th>
              <th className="px-6 pb-4 pt-5">Available Total</th>
            </tr>
          </thead>
          <tbody>
            {data.map(
              ({
                id,
                hospital_name,
                beds,
                package_name,
                firm,
                supervisor,
                hospital_id,
                available_supervisor,
                janitors,
                available_janitors,
                sewer_men,
                available_sewer_men,
                total,
                available_total,
                deleted_at
              }) => {
                return (
                  <tr
                    key={id}
                    className="focus-within:bg-gray-100 hover:bg-gray-100"
                  >
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {id}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.hospital', {
                          service: String(type).toLowerCase(),
                          hospital: hospital_id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {hospital_name}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                      >
                        {beds}
                        {deleted_at && (
                          <Icon
                            name="trash"
                            className="ml-2 h-3 w-3 flex-shrink-0 fill-current text-gray-400"
                          />
                        )}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {package_name}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {firm}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {supervisor}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {available_supervisor}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {janitors}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {available_janitors}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {sewer_men}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {available_sewer_men}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {total}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {available_total}
                      </Link>
                    </td>
                    <td className="w-px border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.edit', {
                          service: type.toLowerCase(),
                          hr: id
                        })}
                        className="flex items-center px-4 focus:outline-none"
                      >
                        <Icon
                          name="cheveron-right"
                          className="block h-6 w-6 fill-current text-gray-400"
                        />
                      </Link>
                    </td>
                  </tr>
                )
              }
            )}
            {data.length === 0 && (
              <tr>
                <td className="border-t px-6 py-4" colSpan="4">
                  No users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination links={links} />

      <DesignationTable users={users} id={null} canAdd={false} />
    </div>
  )
}

Index.layout = page => <Layout title="HR Firm" children={page} />

export default Index
